import { render, staticRenderFns } from "./NeedsDocuments.vue?vue&type=template&id=1521e4ca&scoped=true&"
import script from "./NeedsDocuments.vue?vue&type=script&lang=js&"
export * from "./NeedsDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521e4ca",
  null
  
)

export default component.exports